import { values, pick } from 'lodash'

import { createOptionsFromEnum } from '../utils/createOptionsFromEnum'

export const DIPLOMAS = {
  OTHER: 'OTHER',
  BAM: 'BAM',
  BASM: 'BASM',
  BCDHM: 'BCDHM',
  BCEHM: 'BCEHM',
  BQTM: 'BQTM',
  'BQTM hiver': 'BQTM hiver',
  'BQTM été': 'BQTM été',
  BSM: 'BSM',
  'CDHM hiver': 'CDHM hiver',
  'CDHM été': 'CDHM été',
  'CEHM hiver': 'CEHM hiver',
  'CEHM été': 'CEHM été',
  GUIDE: 'GUIDE',
  MGM: 'MGM',
}

export const DIPLOMAS_ARRAY = values(DIPLOMAS)
export const EXPERT_DIPLOMAS_ARRAY = values(pick(DIPLOMAS, [DIPLOMAS.MGM, DIPLOMAS.GUIDE]))
export const DIPLOMAS_OPTIONS = createOptionsFromEnum({ values: DIPLOMAS_ARRAY })
